import React, { Component } from "react";
import axios from 'axios';
import api from '../common/api';
import { withStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import { Container, Row, Col } from "shards-react";
import Button from "@material-ui/core/Button";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const useStyles = theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
	appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: '2rem',
    flex: 1,
    color: 'white'
  },
  paper: {
    padding: '2rem',
    textAlign: 'center',
  },
  checkedIcon:{
	  width: 16,
      height: 16,
  },
  option:{
  	  fontWeight: 600,
      fontSize:'0.75rem',
  },
  typography:{
	  fontSize: '0.75rem'
  },
  select:{
  	marginTop: '0',
  	marginRight:'12px',
  	padding: '0'
  },
  menu:{
  	fontSize: '0.75rem',
  },
  tableCell:{
  	padding: '0px 6px',
  	width: '90px'
  }
});

class TaxVerificationDateUpdate extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
      				snackbar:{open:false, severity: ''},
      				contact:{provider:{}, client:{},taxes:{}},
		}
  	}

    async componentDidMount() {
    	var contact_id = this.props.match.params.contact_id
    	await this.getContact(contact_id)
    }

    getContact = (id) =>{
		const token = localStorage.getItem('userToken')
		axios.get(api.contacts().get(id),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		var contact = this.state.contact
	      		contact = res.data
	      		contact.taxes.document_number = contact.taxes.document_number.replaceAll('-','')
	      		this.setState({contact: contact, loading: false})
	      })
	      .catch(err =>{console.log(err)
	      })    	
    }

    handleSnackbar = (e) => {
    	e.preventDefault()
    	var snackbar = this.state.snackbar
    	snackbar.open = !snackbar.open
    	this.setState({snackbar: snackbar})
    }

    handleSubmit = (e) => {
    	e.preventDefault();
	    var formData = new FormData();
	    var contact = this.state.contact
	    formData.set("contact_id", this.state.contact.id);
	    let self = this
	    const token = localStorage.getItem('userToken')
	    axios.post(api.contacts().updateCuitVerificationDateNoAfip(),
	       formData,
	       {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
	       )
	      .then((response)=> {
	      		var snackbar = this.state.snackbar
	      		snackbar.open = true
	      		snackbar.severity = 'success'
	      		snackbar.success_message = 'Fecha actualizada con éxito'
		  		this.setState({snackbar:snackbar})
		  		this.getContact(this.state.contact.id)
	      })
	      .catch(function (error) {
				var error_message = 'Ha ocurrido un error. Contacte a su administrador'
	      		if (error.response.status){
					error_message = 'No cuenta con los permisos para actualizar la fecha'	      			
	      		}
	      		var snackbar = {open: true, success_message: error_message, severity: 'warning'}
		  		self.setState({ snackbar: snackbar})
	    })
    }

  	render(){
		const classes = this.props.classes;	
  		return (
	  			<React.Fragment>
		        <Container fluid className="main-content-container px-4 position-relative">
					<Row noGutters className="page-header">
					  <Typography variant="h6">Actualizar fecha de verificación</Typography>
					</Row>
					<div className="row col-12 mt-2 ml-2">
						<Snackbar open={this.state.snackbar.open} onClose={this.handleSnackbar}>
							<Alert onClose={this.handleSnackbar} severity={this.state.snackbar.severity}>
							  {this.state.snackbar.success_message}
							</Alert>
						</Snackbar>
					</div>
					<div className="row col-12 mt-2 ">
						<TextField
							id="name"
							value={(this.state.contact.provider) ? this.state.contact.provider.business_name : this.state.contact.client.business_name}
							disabled={true}
							type="text"
							required
							name="name"
							margin="normal"
							className="m-0 p-0 mr-2 mt-2"
							InputLabelProps={{
								shrink: true
							}}
				          	InputProps={{
					            startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 100}}>Contacto</Typography></InputAdornment>,
							}}
							inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}}
						/>
						<TextField
							id="name"
							value={this.state.contact.taxes.document_number}
							disabled={true}
							type="text"
							required
							name="name"
							margin="normal"
							className="m-0 p-0 mr-2 mt-2"
							InputLabelProps={{
								shrink: true
							}}
				          	InputProps={{
					            startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 50}}>CUIT</Typography></InputAdornment>,
							}}
							inputProps={{style:{minWidth: 120, fontSize: '0.75rem'}}}
						/>
						<TextField
							id="cuit_date_verification"
							value={this.state.contact.taxes.cuit_date_verification}
							disabled={true}
							type="text"
							required
							name="cuit_date_verification"
							margin="normal"
							className="m-0 p-0 mt-2"
							InputLabelProps={{
								shrink: true
							}}
				          	InputProps={{
					            startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 100}}>Fecha hasta</Typography></InputAdornment>,
							}}
							inputProps={{style:{minWidth: 120, fontSize: '0.75rem'}}}
						/>
					</div>
					<div className="row col-12 mt-2">
						<Button variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={(e) => {this.handleSubmit(e)}}>Actualizar fecha</Button>
						<Button className="mx-2" variant="contained" color="secondary" size="small" style={{fontSize: '0.75rem'}} onClick={(e) => {window.location.href='/providers'}}>Volver</Button>
					</div>
				</Container>
			</React.Fragment>
		)
  	}
}

export default withStyles(useStyles)(TaxVerificationDateUpdate);
